import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Link, Typography, IconButton, Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    boxShadow: `0 0 10px ${theme.palette.grey[200]}`,
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5)
  },
  label: {
    marginLeft: theme.spacing(1)
  },
  breadcrumbs: {
    padding: theme.spacing(0, 0.75),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.fontSizeLarge
  },
  separator: {
    margin: 0
  },
  typography: {
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.fontSizeLarge
  },
  link: {
    color: theme.palette.text.primary,
    '&:hover, &:focus, &:active': {
      textDecoration: 'none',
      color: theme.palette.primary.main
    }
  },
  badge: {
    fontSize: theme.typography.fontSizeSmall
  }
}));

export const PdfEditorTemplateHeader = ({ language, template }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <IconButton href={`/${language}/pdf-editor`}>
        <Icon type='arrow-left' color='grey' />
      </IconButton>
      <Breadcrumbs
        classes={{
          root: classes.breadcrumbs,
          separator: classes.separator
        }}
        separator={
          <Icon
            type='chevron-right'
            fill='grey'
            size='md'
          />
        }
      >
        <Link href={`/${language}/pdf-editor`} className={classes.link}>
          <Translate content='pdf_editor_templates' />
        </Link>
        <Typography className={classes.typography}>{template.name}</Typography>
      </Breadcrumbs>
      {
        template.default &&
          (
            <Chip
              variant='outlined'
              size='small'
              color='primary'
              label={
                <Typography noWrap className={classes.badge}>
                  <Translate content='default' />
                </Typography>
              }
            />
          )
      }
    </div>
  );
};

PdfEditorTemplateHeader.propTypes = {
  language: PropTypes.string,
  template: PropTypes.shape({
    name: PropTypes.string
  })
};

export default PdfEditorTemplateHeader;
